import { get, post } from "@/request/http";

// 获取智慧任务列表
export const getdatas = params => get("/api/admin/getdatas", params);
// 获取单个智慧任务
export const getdatasbyid = params => get("/api/admin/getdatasbyid", params);
// 添加智慧任务
export const adddatas = params => post("/api/admin/adddatas", params);
// 审核智慧任务
export const updatedatas = params => post("/api/admin/updatedatas", params);
// 删除智慧任务
export const deletedatas = params => post("/api/admin/deletedatas", params);
// 获取智慧剩于次数
export const getdatanums = params => get("/api/admin/getdatanums", params);



// WEBPACK FOOTER //
// ./src/api/unicomData.js